import { render, staticRenderFns } from "./ProviderContactPromotePrimaryButtons.vue?vue&type=template&id=49205914&"
import script from "./ProviderContactPromotePrimaryButtons.vue?vue&type=script&lang=js&"
export * from "./ProviderContactPromotePrimaryButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports